import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider, useAdminAuth } from "@/context/AdminAuth";
import Home from "@/pages/Home";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ProtectedAdmin({ children }) {
  const { admin } = useAdminAuth();
  if (admin === undefined) {
    return <div className="min-h-screen bg-ink flex items-center justify-center text-gold">Loading…</div>;
  }
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AdminAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </AdminAuthProvider>
  );
}

export default App;
